import React from "react";
import { Input } from "../../../../components/common/Input";

type Props = {
    value: string;
    onChange: (v: string) => void;
};

export const SearchBar: React.FC<Props> = ({ value, onChange }) => {
    return (
        <div className="border-y border-slate-200 bg-white px-4 py-3 sm:rounded-2xl sm:border sm:px-5">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-5">
                <div className="shrink-0">
                    <div className="text-sm font-semibold text-slate-800">Поиск</div>
                    <div className="mt-0.5 text-xs text-slate-500">Имя, телефон, почта или тариф</div>
                </div>
                <div className="min-w-0 flex-1">
                <Input
                    value={value}
                    onChange={onChange}
                    name="subscribedUsersSearch"
                    type="text"
                    placeholder="Имя / телефон / email / план"
                    label={null}
                />
                </div>
            </div>
        </div>
    );
};
